<div class="version-list-checkbox">
  <div class="version-list-align" (click)="openFiles()">
    <div class="version-files-list-id-data" >
      <div class="version-list-id" [ngClass]="{'arrow-marker-open': opened,'arrow-marker-closed': !opened}">
        <span>{{version.id}}</span>
      </div>
      <div class="version-blue">
      <core-helpers-icons-blue-circle [hidden]="!checked"></core-helpers-icons-blue-circle>
      </div>
      <div class="version-bubbles-dimmed version-bubbles-related dimmed" *ngIf="feedbacksList == null">
        <div class="dimmed_flex">
          <span></span><span></span><span></span>
        </div>
      </div>
      <div class="version-files-list-item-feedabcks">
        <div class="version-feedback-bubble" *ngFor="let feedback of feedbacksList">
          <core-helpers-icons-colored-bubble-circle-letter [title]="feedback.user.name"
            [color]="getBubbleColor(feedback)"></core-helpers-icons-colored-bubble-circle-letter>
        </div>
      </div>
    </div>
    <div class="version-files-list-item-data" >
      <core-status-name
      [status]="version.status"
      ></core-status-name>
      <div class="version-files-list-item-version" title="{{version.version}}">
        <strong>{{version.version}}</strong>
      </div>
    </div>
  </div>
  <core-commons-files-list-checkbox
    *ngIf="firstOpened"
    [hidden]="!opened"
    [counter]="false"
    [url]="filesUrl"
    [selected]="selected"
    (selectedChange)="onChange($event);"
    [(checked)]="checked"
    [disabled]="disabled"
  ></core-commons-files-list-checkbox>
</div>
